// extracted by css-extract-rspack-plugin
export default {"resizableBox":"aY0Gb"};